export default __webpack_public_path__ + "static/tempusfinance-f3f19b0d63756b50578c4b0edf831e05.jpg";